import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'public';
const fullUserInfoJSON = localStorage.getItem(location.hostname + '-fullUserInfo');
if (fullUserInfoJSON) {
  const fullUserInfo = JSON.parse(fullUserInfoJSON);
  if (fullUserInfo && fullUserInfo.CoreRole) {
    initialRole = fullUserInfo.CoreRole;
  }
}

export default new AclCreate({
  initial: initialRole,
  notfound: '/pages/not-authorized?returnUrl=' + window.location.href,
  router,
  acceptLocalRules: true,
  globalRules: {
    admin: new AclRule('admin').generate(),
    editor: new AclRule('editor').or('admin').generate(),
    guest: new AclRule('guest').or('editor').or('admin').generate(),
    anonymous: new AclRule('anonymous').or('guest').or('editor').or('admin').generate(),
    public: new AclRule('public').or('anonymous').or('guest').or('editor').or('admin').generate()
  }
})
